module.exports = __webpack_public_path__ + "static/media/moon.b3dc8c09.png";